module.exports = __webpack_public_path__ + "img/grey-podcasts-3.b6fbddfb.png";